import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";
import { HttpService } from "src/app/shared/services/http.service"
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-share-dialog',
  templateUrl: './share-dialog.component.html',
  styleUrls: ['./share-dialog.component.css']
})
export class ShareDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private httpService: HttpService,
    private snackBar: MatSnackBar
  ) {
    console.log("data : ", data)
    this.shareForm = this._formBuilder.group({
      duration: new FormControl(null),
      medium: new FormControl(null),
      message: new FormControl(null)
    })
  }

  shareForm: FormGroup
  days: Array<number> = [1, 7, 14, 30]

  share() {
    let formData = { ...this.shareForm.value }
    let apiUrl = `/share`
    formData[this.data.shareVia] = formData.medium
    delete formData.medium
    console.log("formData is : ", formData)
    this.httpService.post(apiUrl, formData).subscribe((response: any) => {
      if (response.status === "OK") {
        console.log("API was successful : ", response)
        this.snackBar.open("Careplan shared successfully!", "Cancel", { duration: 2000 })
      } else {
        this.snackBar.open("There was an error sharing the careplan, please try again later", "Cancel", { duration: 2000 })
      }
    },
      (error: any) => {
        this.snackBar.open("There was an error sharing the careplan, please try again later", "Cancel", { duration: 2000 })
      })
  }

}
